import React from "react";
import withSizePositionAngle from "components/withSizePositionAngle";


const _ChairMaria = () => {
    return (
        <g transform="translate(-16.280862 -169.173350)">
          <path fill="#803300" fillOpacity="1" stroke="none" strokeWidth="0.68299" stopColor="#000000" d="m 16.280862,169.17335 v 95.74935 h 4.327374 v -38.76858 h 36.204719 v 38.76858 h 4.327375 v -38.76858 -4.2838 H 56.812955 20.608236 v -52.69697 z"/>
        </g>
    );
}

const ChairMaria = withSizePositionAngle(_ChairMaria, 44.859468, 95.749350);

export default ChairMaria;